import Vue from 'vue';
import GLightbox from 'glightbox';
import '../Styles/Main.css';
import VideoDf1 from './ContentElements/VideoDf1';
import TabList from './ContentElements/TabList';
import Slider from './ContentElements/Slider';
import Overview from './ContentElements/Overview';
import Accordion from './ContentElements/Accordion';
import './Utillity/Header';
import './Utillity/Modal';
import './Utillity/Bookmarks';
import bootstrap from 'bootstrap/dist/js/bootstrap';

const IS_PROD = false;

Vue.config.productionTip = !IS_PROD;
Vue.config.devtools = !IS_PROD
Vue.config.performance = !IS_PROD

const lightbox = GLightbox({
	touchNavigation: true,
	onOpen: () => {
		// Need to execute a script on open?
		// You can do that here...
	},
	beforeSlideLoad: (slide, data) => {
		// Need to execute a script in the slide?
		// You can do that here...
	},
});

/**
 * Autoloading components from "Components"-directory
 */
require.context('./Components/', true, /\.vue$/).keys().forEach(function (elementPath) {
	let component = require('./Components/' + elementPath.replace('./', '')).default;
	if (typeof (component.name) == 'undefined') {
		console.warn('Component is missing name!', component);
		return;
	}
	Vue.component(component.name, component);
});

/**
 * Autoloading components from "Components"-directory (EXT:storefinder)
 */
require.context('../../../../../storefinder/Resources/Private/Assets/Scripts/Components/', true, /\.vue$/).keys().forEach(function (elementPath) {
	let component = require('../../../../../storefinder/Resources/Private/Assets/Scripts/Components/' + elementPath.replace('./', '')).default;
	if (typeof (component.name) == 'undefined') {
		console.warn('Component is missing name!', component);
		return;
	}
	Vue.component(component.name, component);
});

Vue.directive('click-outside', {
	bind: function (el, binding, vnode) {
		el.event = function (event) {
			// here I check that click was outside the el and his childrens
			if (!(el == event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener('click', el.event);
	},
	unbind: function (el) {
		document.body.removeEventListener('click', el.event);
	},
});
const allowedModalTags = ['modal-dialog', 'share-modal-dialog', 'reference-modal-dialog'];
Vue.directive('modal-trigger', {
	inserted: function (el, binding, vnode) {
		el.addEventListener('click', () => {
			const modalId = binding.value;
			const root = vnode.context.$root;
			const modal = root.$refs[modalId];
			if (!modal) {
				throw 'Your modal is not registered as ref within in the $root component';
			}
			if (!allowedModalTags.includes(modal.$options._componentTag)) {
				throw 'Use modal-trigger in combination with one of these components:' + allowedModalTags + '.';
			}
			modal.toggleModal();
		});
	},
});

Vue.mixin({
	filters: {
		print(value) {
			console.log(value);
			return value;
		},
	},
});

import store from '../../../../../storefinder/Resources/Private/Assets/Scripts/Store';

new Vue({
	store,
	el: '.vue',
	data() {
		return {
			state: {},
		};
	},
	created() {
		this.lightbox = lightbox;
		this.$store.dispatch('loadBookmarksFromCookie');

		window.addEventListener('storage', (event) => {
			if (event.newValue === 'onBookmarkChange') {
				// Update the bookmark state because it has changed in another tab/window.
				this.$store.dispatch('loadBookmarksFromCookie');
			}
		});
	},
	methods: {
		hasState(id, value) {
			return this.state[id] == value;
		},
		goBack(evt) {
			window.history.back();
		},
		lightboxReload() {
			this.$nextTick(() => {
				this.lightbox.reload();
			});
		},
	},
});

document.addEventListener("DOMContentLoaded", (event) => {

	// for (const node of document.querySelectorAll('.video-df1')) {
	//   new VideoDf1(node);
	// }

	for (const node of document.querySelectorAll('.tab-list')) {
		new TabList(node);
	}

	for (const node of document.querySelectorAll('.swiper')) {
		new Slider(node);
	}

	// for (const node of document.querySelectorAll('.overview')) {
	//   new Overview(node);
	// }

	for (const node of document.querySelectorAll('.accordion')) {
		new Accordion(node);
	}
});
